/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PublicKeyCredentialParams } from './PublicKeyCredentialParams';
import {
    PublicKeyCredentialParamsFromJSON,
    PublicKeyCredentialParamsFromJSONTyped,
    PublicKeyCredentialParamsToJSON,
    PublicKeyCredentialParamsToJSONTyped,
} from './PublicKeyCredentialParams';
import type { CredentialType } from './CredentialType';
import {
    CredentialTypeFromJSON,
    CredentialTypeFromJSONTyped,
    CredentialTypeToJSON,
    CredentialTypeToJSONTyped,
} from './CredentialType';

/**
 * 
 * @export
 * @interface ExportedPublicKeyCredential
 */
export interface ExportedPublicKeyCredential {
    /**
     * The ID of the credential
     * @type {string}
     * @memberof ExportedPublicKeyCredential
     */
    id: string;
    /**
     * The time when the credential was last used to authenticate successfully
     * @type {Date}
     * @memberof ExportedPublicKeyCredential
     */
    last_used?: Date;
    /**
     * 
     * @type {CredentialType}
     * @memberof ExportedPublicKeyCredential
     */
    type: CredentialType;
    /**
     * 
     * @type {PublicKeyCredentialParams}
     * @memberof ExportedPublicKeyCredential
     */
    params: PublicKeyCredentialParams;
    /**
     * 
     * @type {string}
     * @memberof ExportedPublicKeyCredential
     */
    label?: string;
}



/**
 * Check if a given object implements the ExportedPublicKeyCredential interface.
 */
export function instanceOfExportedPublicKeyCredential(value: object): value is ExportedPublicKeyCredential {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('params' in value) || value['params'] === undefined) return false;
    return true;
}

export function ExportedPublicKeyCredentialFromJSON(json: any): ExportedPublicKeyCredential {
    return ExportedPublicKeyCredentialFromJSONTyped(json, false);
}

export function ExportedPublicKeyCredentialFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportedPublicKeyCredential {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'last_used': json['last_used'] == null ? undefined : (new Date(json['last_used'])),
        'type': CredentialTypeFromJSON(json['type']),
        'params': PublicKeyCredentialParamsFromJSON(json['params']),
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function ExportedPublicKeyCredentialToJSON(json: any): ExportedPublicKeyCredential {
    return ExportedPublicKeyCredentialToJSONTyped(json, false);
}

export function ExportedPublicKeyCredentialToJSONTyped(value?: ExportedPublicKeyCredential | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'last_used': value['last_used'] == null ? value['last_used'] : value['last_used'].toISOString(),
        'type': CredentialTypeToJSON(value['type']),
        'params': PublicKeyCredentialParamsToJSON(value['params']),
        'label': value['label'],
    };
}

